<div p500UITooltip #tmpl [tooltipData]="template?.nativeElement?.innerHTML" [allowTags]="true" className="с-pql-field--tooltip">
  <div class="с-pql-field-new--typed-new">
    <ng-container *ngFor="let item of parsePql; index as i">
      <div class="с-pql-field-new--typed-new">
        <div class="с-pql-field-new__type с-pql-field-new" [ngClass]="item.cssClass">
          {{ item.type }}
        </div>
        <span>
          <b>
            <small>
              {{ item.operator }}
            </small>
          </b>
        </span>
        <div *ngIf="item.data?.length" class="с-pql-field-new__name">{{ item.data }}</div>
        <span *ngIf="parsePql[i + 1]?.config as config">
          <b>
            <small>
              {{ config }}
            </small>
          </b>
        </span>
      </div>
    </ng-container>
  </div>
</div>
